import { AxiosResponse } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { INotificationPreferencesRequest, NotificationTypeEnum } from './me-notification-preferences-service.types'

export const fetchNotificationPreferences = async (): Promise<NotificationTypeEnum> => {
  const { data } = await axios.get<INotificationPreferencesRequest>(apiEndpoints.ME_PREFERENCES)  
  return data?.preferences?.schedule_notification_type
}

export const updateNotificationPreferences = async (notificationType: NotificationTypeEnum): Promise<AxiosResponse> => {
  const response = await axios.put<INotificationPreferencesRequest>(
    apiEndpoints.ME_PREFERENCES, 
    { 
      schedule_notification_type: notificationType 
    })
  
  return response
}